var version = {
    "name":      "dativery",
    "buildDateCode": "20251208-112530",
    "buildDate": "Mon Dec 08 2025 11:25:30 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251208-112530",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;